export default __webpack_public_path__ + "static/media/personal-photo-dark.8cd86d12.svg";